
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/secondary",
      function () {
        return require("private-next-pages/secondary/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/secondary"])
      });
    }
  